export default "__VITE_ASSET__tOv__99k__"